module.exports = __webpack_public_path__ + "img/2.95637b17.png";